import React from "react";

const Actions = ({ label, actions, variant }) => {
  return (
    <div
      className={`lmfActions__area ${variant ? `lmfActions__area--${variant}` : ""}`}
    >
      <div className="lmfActions__area--left">
        <span dangerouslySetInnerHTML={{ __html: label }}></span>
      </div>
      <div className="lmfActions__area--right">
        <div className="d-flex">{actions}</div>
      </div>
    </div>
  );
};

export default Actions;
